import React, {Component, PropTypes} from 'react';
import QS from 'querystring';

class PandoLogicTrackingPixel extends Component {
  static propTypes = {
    conversionType: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      trackingURL: 'https://tracking.pandoiq.com/22419',
      conversionType: this.props.conversionType || ''
    };
  }

    componentDidMount () {
//  PandoLogic Tracking Pixel
    const qsParms = QS.parse((window.location.search).substring(1));
    if (qsParms && qsParms.pando_clickuid) {
      this.appendScript(this.state.trackingURL);
    }
  }

  componentWillUnmount () {
//  PandoLogic Tracking Pixel
    const queryString = QS.parse((window.location.search).substring(1));
    if (queryString && queryString.pando_clickuid) {
      this.removeScript(this.state.trackingURL);
    }
  }

  // dynamically add script to component
  appendScript = (scriptToAppend) => {
    const script = document.createElement('script');
    script.src = scriptToAppend;
    script.async = true;
    document.body.appendChild(script);
  }

  // dynamically remove script to component
  removeScript = (scriptToRemove) => {
    const allsuspects=document.getElementsByTagName('script');
    for (let i=allsuspects.length; i>=0; i--) {
      if (allsuspects[i] && allsuspects[i].getAttribute('src')!==null
        && allsuspects[i].getAttribute('src').indexOf(`${scriptToRemove}`) !== -1) {
        allsuspects[i].parentNode.removeChild(allsuspects[i]);
      }
    }
  }

  render() {
    return (
      <div>
        <div ref={(el) => (this.instance = el)} />
    </div>
    );
  }
}

export default PandoLogicTrackingPixel;




// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/PandoLogicTrackingPixel/index.js